import { getSizeSettings } from "../../../utils/get-size-settings";
import { ViewObjectContainerParser } from "../view-object-container-parser";
import { SettingsParser } from "../settings-parser";
import { TableSettings } from "../../settings/view-objects/table-settings";

export class TableSettingsParser extends ViewObjectContainerParser {
  constructor(viewObjectParsers) {
    super(viewObjectParsers);
    this.parsedFieldNames.push("rows");
    this.parsedFieldNames.push("columns");
    this.parsedFieldNames.push("rowsSpace");
    this.parsedFieldNames.push("columnsSpace");
    this.parsedFieldNames.push("mergedCells");
    this.parsedFieldNames.push("items");
  }

  static createSettings(settings, defaultSettings, viewObjectParsers) {
    let parsedSettings = ViewObjectContainerParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    if (settings.rows !== undefined) {
      parsedSettings.rows = [];
      for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
        let rowSettings = settings.rows[rowIndex];
        parsedSettings.rows.push({
          height: getSizeSettings(rowSettings.height ?? defaultSettings?.rowSettings?.height, 0, 1)
        });
      }
    }
    if (settings.columns !== undefined) {
      parsedSettings.columns = [];
      for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
        let columnSettings = settings.columns[columnIndex];
        parsedSettings.columns.push({
          width: getSizeSettings(columnSettings.width ?? defaultSettings?.columnSettings?.width, 0, 1)
        });
      }
    }
    parsedSettings.rowsSpace = getSizeSettings(settings.rowsSpace ?? defaultSettings?.rowsSpace, 0, 0);
    parsedSettings.columnsSpace = getSizeSettings(settings.columnsSpace ?? defaultSettings?.columnsSpace, 0, 0);
    if (settings.mergedCells !== undefined) {
      parsedSettings.mergedCells = [];
      for (let cellIndex = 0; cellIndex < settings.mergedCells.length; cellIndex++) {
        let mergedCellInfo = settings.mergedCells[cellIndex];
        parsedSettings.mergedCells.push({
          rowBegin: mergedCellInfo.rowBegin,
          rowEnd: mergedCellInfo.rowEnd,
          columnBegin: mergedCellInfo.columnBegin,
          columnEnd: mergedCellInfo.columnEnd
        });
      }
    }
    if (settings.items !== undefined) {
      parsedSettings.items = [];
      let defaultViewObjects = settings._defaultViewObjects;
      for (let rowIndex = 0; rowIndex < settings.items.length; rowIndex++) {
        let rowItems = settings.items[rowIndex];
        let rowItemsCopies = [];
        for (let columnIndex = 0; columnIndex < rowItems.length; columnIndex++) {
          let parsedItem = ViewObjectContainerParser.parseItem(rowItems[columnIndex], viewObjectParsers, defaultViewObjects);
          rowItemsCopies.push(parsedItem);
        }
        parsedSettings.items.push(rowItemsCopies);
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = TableSettingsParser.createSettings(settings, defaultSettings, this.viewObjectParsers);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new TableSettings(parsedSettings);
  }
}
